module.exports = __webpack_public_path__ + "static/img/carte_mexique.284df5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/carte_mexique.jpg
// module id = 26
// module chunks = 0